import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Input } from '../ui/input';
import { Switch } from '../ui/switch';
import { Users, GraduationCap, Heart, Search, Briefcase } from 'lucide-react';

export default function AlumniBrowseTab({ profiles, searchQuery, setSearchQuery, mentorsOnly, setMentorsOnly, openConnectDialog }) {
  const filteredProfiles = profiles.filter(p => 
    !searchQuery || 
    p.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    p.skills?.some(s => s.toLowerCase().includes(searchQuery.toLowerCase())) ||
    p.mentorship_areas?.some(a => a.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  return (
    <div className="space-y-4">
      <Card className="border-0 shadow-sm rounded-2xl">
        <CardContent className="p-4">
          <div className="flex flex-col md:flex-row gap-3">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" size={16} />
              <Input placeholder="Search by name, skills, or mentorship areas..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="pl-9 rounded-xl" />
            </div>
            <div className="flex items-center gap-2">
              <Switch checked={mentorsOnly} onCheckedChange={setMentorsOnly} />
              <span className="text-sm">Mentors only</span>
            </div>
          </div>
        </CardContent>
      </Card>

      {filteredProfiles.length === 0 ? (
        <Card className="border-0 shadow-sm rounded-2xl">
          <CardContent className="p-8 text-center">
            <Users className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
            <p className="text-muted-foreground">No alumni profiles found.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {filteredProfiles.map(profile => (
            <Card key={profile.id} className="border-0 shadow-sm rounded-2xl hover:shadow-md transition-shadow">
              <CardContent className="p-4">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
                    <GraduationCap className="text-emerald-600" size={28} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2">
                      <div>
                        <h3 className="font-semibold">{profile.name}</h3>
                        {profile.current_employment && (
                          <p className="text-sm text-muted-foreground flex items-center gap-1"><Briefcase size={12} /> {profile.current_employment}</p>
                        )}
                      </div>
                      {profile.available_for_mentorship && (
                        <Badge className="bg-emerald-100 text-emerald-700 shrink-0">Mentor</Badge>
                      )}
                    </div>
                    {profile.bio && <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{profile.bio}</p>}
                    {profile.skills?.length > 0 && (
                      <div className="flex flex-wrap gap-1 mt-2">
                        {profile.skills.slice(0, 4).map((skill, idx) => (
                          <Badge key={`item-${idx}`} variant="outline" className="text-xs">{skill}</Badge>
                        ))}
                        {profile.skills.length > 4 && <Badge variant="outline" className="text-xs">+{profile.skills.length - 4}</Badge>}
                      </div>
                    )}
                    {profile.available_for_mentorship && (
                      <Button size="sm" onClick={() => openConnectDialog(profile)} className="mt-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-full gap-1">
                        <Heart size={14} /> Request Mentorship
                      </Button>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
